import { message } from '@rendora/common/composables/message';
import { PositionCode } from '@rendora/common/entities/analysis_backend';
import { getOrderClientRemainedBuyCreditCoinsCount } from '@rendora/common/entities/order';
import { getRightsCreditCoinsPackage } from '@rendora/common/entities/rights';
import { showDynamicContact } from '@rendora/common/features/contact';
import { ModalFactory } from '@rendora/common/features/modals/factory';
import { getI18nService } from '@rendora/common/services/i18n';
import { useUserStore } from '@rendora/common/store/user';
import { IRightsType, ORDER_TYPE } from '@rendora/common/types/enums';
import { Link } from '@rendora/design/components/link/index';
import { usePayment } from '../../store';
import { showPaymentModal } from '../pay-modal';
import BuyCredit from './BuyCredit.vue';
import Limit from './Limit.vue';
import { buyCreditSymbol, limitModalSymbol } from './symbols';

export const showBuyCreditModal = async () => {
  const i18nService = getI18nService();
  const $t = i18nService.t;
  ModalFactory.clear();

  const paymentStore = usePayment();

  await paymentStore.checkPurchaseLimit(ORDER_TYPE.CREDITS);

  // 需要根据账号类型进行判断：个人体验版和团队体验版是不能做加购的，企业标准版和企业旗舰版是不能线上加购的，需要商务介入
  // 团队入门版是有加购上限的，到达加购上限也是不能加购的

  // 是否允许加购言币
  const { user } = useUserStore();
  if (!user?.rights_record.allow_add_coin) {
    const isTeam = user?.rights_type === IRightsType.TEAM_LIGHT;
    message.info({
      content: (
        <div>
          {isTeam
            ? $t('yan-bi-bu-zu-qing-lian-xi-nin-de-shang-wu-fu-ze-ren')
            : $t('yan-bi-bu-zu-qing-lian-xi-wo-men')}
          {isTeam && (
            <Link
              onClick={() => showDynamicContact(PositionCode['有言官网权益管理加购言币'])} // @xi18n-ignore
              style={{ marginLeft: '50px' }}
              type="info"
            >
              {$t('lian-xi-wo-men')}
            </Link>
          )}
        </div>
      ),
    });
    return;
  }

  // 团队入门版的天选逻辑
  if (user?.rights_type === IRightsType.TEAM_LIGHT) {
    const res1 = await getOrderClientRemainedBuyCreditCoinsCount();
    const res2 = await getRightsCreditCoinsPackage({
      many: '1',
      rights_type: user.rights_type!,
    });
    const remained_credit_coins = res1.data?.remained_credit_coins;
    let isBuyable = true;

    if (Number.isInteger(remained_credit_coins)) {
      isBuyable = (res2.data || []).some(v => v.total_credit_coins <= remained_credit_coins!);
    }

    if (!isBuyable) {
      ModalFactory.create(
        {
          content: <Limit />,
        },
        limitModalSymbol,
      );
      return;
    }
  }

  showPaymentModal(<BuyCredit />, { title: $t('jia-gou-yan-bi') }, buyCreditSymbol);
};
